import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';
import API from '@/config/api';

const cache = {};

// Current user's access rules (teacher pages, classrooms, driver toggles). Cached per user for the session.
export const useStaffAccess = () => {
  const { user, getAuthHeaders } = useAuth();
  const [access, setAccess] = useState(user ? cache[user.id]?.data : null);
  useEffect(() => {
    if (!user || !['provider', 'driver'].includes(user.role)) return;
    if (!cache[user.id]) cache[user.id] = { promise: axios.get(`${API}/staff-access/me`, getAuthHeaders()).then((r) => r.data) };
    let alive = true;
    cache[user.id].promise.then((data) => { cache[user.id].data = data; if (alive) setAccess(data); }).catch(() => { delete cache[user.id]; });
    return () => { alive = false; };
  }, [user, getAuthHeaders]);
  return access;
};
